//import { findIndex, isEmpty } from 'lodash';

import * as constants from './Order.constants';
import * as services from './Order.service';

//import { UPDATE_USER_INFO_SUCCESS } from '@/constants';

const state = {
  order: {},
  checkResult: 0,
  checkResultMessage: '',
  imgQr: {},
  checkScanResult: 0,
  paypalURL: '',
  webAlipayPageSnapletHtml: '',
  taobaoOrderResult: {
    message: '',
    data: false,
  },
  couponList: [],
  isRequest: false,
  isRequestCheck: false,
  isRequestCouponList: false,
};

const mutations = {
  [constants.GET_MALL_GOOD_QRCODE_SUCCESS](state, order) {
    if (undefined !== order && null !== order) {
      state.order = order;
    }
  },

  [constants.SET_CHECK_RESULT](state, payload) {
    state.checkResult = payload.checkResult;
    state.checkResultMessage = payload.checkResultMessage;
  },

  [constants.GET_MALL_GOOD_QRCODE_IMGQR](state, imgQr) {
    if (undefined !== imgQr && null !== imgQr) {
      state.imgQr = imgQr;
    }
  },

  [constants.SET_CHECK_SCAN_RESULT](state, payload) {
    state.checkScanResult = payload.checkScanResult;
  },

  [constants.GET_MAKE_MALL_PAYPAL_URL_SUCCESS](state, paypalURL) {
    state.paypalURL = paypalURL;
  },

  [constants.GET_WEB_ALIPAY_PAGE_SNAPLET_SUCCESS](state, snaplet) {
    if (undefined !== snaplet && null !== snaplet) {
      state.webAlipayPageSnapletHtml = snaplet.snaplet;
    }
  },

  [constants.SET_TAOBAO_ORDER_RESULT](state, taobaoOrderResult) {
    if (undefined !== taobaoOrderResult && null !== taobaoOrderResult) {
      state.taobaoOrderResult = taobaoOrderResult;
    }
  },

  [constants.GET_MALL_COUPON_LIST_SUCCESS](state, couponList) {
    if (undefined !== couponList && null !== couponList) {
      state.couponList = couponList;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.SET_IS_REQUEST_CHECK_STATUS](state, status) {
    state.isRequestCheck = status;
  },

  [constants.SET_IS_REQUEST_COUPON_LIST_STATUS](state, status) {
    state.isRequestCouponList = status;
  },

  //[constants.DUMMY_MUTATION]() { },
};

const actions = {
  async _getMallGoodQrcode({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const pms = payload.getMallGoodQrcode(payload.payload);
    const res = await pms;
    commit(constants.GET_MALL_GOOD_QRCODE_SUCCESS, res.data.data);
    commit('Mixins/AddressEdit/UPDATE_ORDER_ADDRESS', res.data.data, { root: true });
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return pms;
  },

  getMallGoodQrcode({ dispatch }, payload) {
    return dispatch('_getMallGoodQrcode', {
      payload,
      getMallGoodQrcode: services.getMallGoodQrcode,
    });
  },

  //getMallGoodQrcodePayed({ dispatch }, payload) {
  //  return dispatch('_getMallGoodQrcode', {
  //    payload,
  //    getMallGoodQrcode: services.getMallGoodQrcodePayed,
  //  });
  //},

  getMallPublicGoodQrcode({ dispatch }, payload) {
    return dispatch('_getMallGoodQrcode', {
      payload,
      getMallGoodQrcode: services.getMallPublicGoodQrcode,
    });
  },

  getMallNormalTradeDetail({ dispatch }, payload) {
    return dispatch('_getMallGoodQrcode', {
      payload,
      getMallGoodQrcode: services.getMallNormalTradeDetail,
    });
  },

  getMallLockpriceDepositTradeDetail({ dispatch }, payload) {
    return dispatch('_getMallGoodQrcode', {
      payload,
      getMallGoodQrcode: services.getMallLockpriceDepositTradeDetail,
    });
  },

  getMallPresellDepositTradeDetail({ dispatch }, payload) {
    return dispatch('_getMallGoodQrcode', {
      payload,
      getMallGoodQrcode: services.getMallPresellDepositTradeDetail,
    });
  },

  getMallLockpriceBalanceTradeDetail({ dispatch }, payload) {
    return dispatch('_getMallGoodQrcode', {
      payload,
      getMallGoodQrcode: services.getMallLockpriceBalanceTradeDetail,
    });
  },

  getMallPresellBalanceTradeDetail({ dispatch }, payload) {
    return dispatch('_getMallGoodQrcode', {
      payload,
      getMallGoodQrcode: services.getMallPresellBalanceTradeDetail,
    });
  },

  async checkMallGoodQrcode({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_CHECK_STATUS, true);
    const res = await services.checkMallGoodQrcode(payload);
    commit(constants.GET_MALL_GOOD_QRCODE_SUCCESS, res.data.data.resultEntity);
    commit(constants.SET_CHECK_RESULT, {
      checkResult: res.data.data.checkResult,
      checkResultMessage: res.data.data.checkResultMessage,
    });
    commit(constants.SET_IS_REQUEST_CHECK_STATUS, false);
  },

  async _makeMallYzQrcode({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const pms = payload.makeMallYzQrcode(payload.payload);
    const res = await pms;
    if (!payload.isTrade) {
      if (undefined !== res.data.data.checkResult && !res.data.data.checkResult) {
        commit(constants.GET_MALL_GOOD_QRCODE_SUCCESS, res.data.data.resultEntity);
        commit(constants.SET_CHECK_RESULT, {
          checkResult: res.data.data.checkResult,
          checkResultMessage: res.data.data.checkResultMessage,
        });
      } else {
        commit(constants.GET_MALL_GOOD_QRCODE_IMGQR, res.data.data.resultEntity);
      }
    } else {
      commit(constants.GET_MALL_GOOD_QRCODE_IMGQR, res.data.data);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return pms;
  },

  makeMallYzQrcode({ dispatch }, payload) {
    return dispatch('_makeMallYzQrcode', {
      payload,
      makeMallYzQrcode: services.makeMallYzQrcode,
      isTrade: false,
    });
  },

  makeMallNormalTradeQrcode({ dispatch }, payload) {
    return dispatch('_makeMallYzQrcode', {
      payload,
      makeMallYzQrcode: services.makeMallNormalTradeQrcode,
      isTrade: true,
    });
  },

  makeMallLockpriceDepositTradeQrcode({ dispatch }, payload) {
    return dispatch('_makeMallYzQrcode', {
      payload,
      makeMallYzQrcode: services.makeMallLockpriceDepositTradeQrcode,
      isTrade: true,
    });
  },

  makeMallPresellDepositTradeQrcode({ dispatch }, payload) {
    return dispatch('_makeMallYzQrcode', {
      payload,
      makeMallYzQrcode: services.makeMallPresellDepositTradeQrcode,
      isTrade: true,
    });
  },

  makeMallLockpriceBalanceTradeQrcode({ dispatch }, payload) {
    return dispatch('_makeMallYzQrcode', {
      payload,
      makeMallYzQrcode: services.makeMallLockpriceBalanceTradeQrcode,
      isTrade: true,
    });
  },

  makeMallWechatQrcode({ dispatch }, payload) {
    return dispatch('_makeMallYzQrcode', {
      payload,
      makeMallYzQrcode: services.makeMallWechatQrcode,
      isTrade: false,
    });
  },

  makeMallNormalTradeWechatQrcode({ dispatch }, payload) {
    return dispatch('_makeMallYzQrcode', {
      payload,
      makeMallYzQrcode: services.makeMallNormalTradeWechatQrcode,
      isTrade: true,
    });
  },

  makeMallLockpriceDepositTradeWechatQrcode({ dispatch }, payload) {
    return dispatch('_makeMallYzQrcode', {
      payload,
      makeMallYzQrcode: services.makeMallLockpriceDepositTradeWechatQrcode,
      isTrade: true,
    });
  },

  makeMallPresellDepositTradeWechatQrcode({ dispatch }, payload) {
    return dispatch('_makeMallYzQrcode', {
      payload,
      makeMallYzQrcode: services.makeMallPresellDepositTradeWechatQrcode,
      isTrade: true,
    });
  },

  makeMallLockpriceBalanceTradeWechatQrcode({ dispatch }, payload) {
    return dispatch('_makeMallYzQrcode', {
      payload,
      makeMallYzQrcode: services.makeMallLockpriceBalanceTradeWechatQrcode,
      isTrade: true,
    });
  },

  async _checkMallScanQrcode({ commit }, payload) {
    const res = await payload.checkMallScanQrcode(payload.payload);
    const checkScanResult = res.data.data;
    commit(constants.SET_CHECK_SCAN_RESULT, {
      checkScanResult,
    });
    return res;
  },

  checkMallScanQrcode({ dispatch }, payload) {
    return dispatch('_checkMallScanQrcode', {
      payload,
      checkMallScanQrcode: services.checkMallScanQrcode,
    });
  },

  checkButtonMallScanQrcode({ dispatch }, payload) {
    return dispatch('_checkMallScanQrcode', {
      payload,
      checkMallScanQrcode: services.checkButtonMallScanQrcode,
    });
  },

  async _makeMallPaypalUrl({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const pms = payload.makeMallPaypalUrl(payload.payload);
    const res = await pms;
    if (res && res.data && res.data.data) {
      commit(constants.GET_MAKE_MALL_PAYPAL_URL_SUCCESS, res.data.data.paypalURL);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return pms;
  },

  makeMallPaypalUrl({ dispatch }, payload) {
    return dispatch('_makeMallPaypalUrl', {
      payload,
      makeMallPaypalUrl: services.makeMallPaypalUrl,
    });
  },

  makeMallNormalTradePaypal({ dispatch }, payload) {
    return dispatch('_makeMallPaypalUrl', {
      payload,
      makeMallPaypalUrl: services.makeMallNormalTradePaypal,
    });
  },

  makeMallLockpriceDepositTradePaypal({ dispatch }, payload) {
    return dispatch('_makeMallPaypalUrl', {
      payload,
      makeMallPaypalUrl: services.makeMallLockpriceDepositTradePaypal,
    });
  },

  makeMallPresellDepositTradePaypal({ dispatch }, payload) {
    return dispatch('_makeMallPaypalUrl', {
      payload,
      makeMallPaypalUrl: services.makeMallPresellDepositTradePaypal,
    });
  },

  makeMallLockpriceBalanceTradePaypal({ dispatch }, payload) {
    return dispatch('_makeMallPaypalUrl', {
      payload,
      makeMallPaypalUrl: services.makeMallLockpriceBalanceTradePaypal,
    });
  },

  //async getWebAlipayPageSnaplet({ commit }, payload) {
  //  commit(constants.SET_IS_REQUEST_STATUS, true);
  //  const res = await services.getWebAlipayPageSnaplet(payload);
  //  commit(constants.GET_WEB_ALIPAY_PAGE_SNAPLET_SUCCESS, res.data.data);
  //  //commit(constants.SET_IS_REQUEST_STATUS, false);
  //},

  //async getWebAlipayWapSnaplet({ commit }, payload) {
  //  commit(constants.SET_IS_REQUEST_STATUS, true);
  //  const res = await services.getWebAlipayWapSnaplet(payload);
  //  commit(constants.GET_WEB_ALIPAY_PAGE_SNAPLET_SUCCESS, res.data.data);
  //  //commit(constants.SET_IS_REQUEST_STATUS, false);
  //},

  async makeMallAlipaySnapletHtml({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.makeMallAlipaySnapletHtml(payload);
    if (res.data.data) {
      let snaplet;
      if (res.data.data.snaplet) {
        snaplet = res.data.data;
      }
      if (res.data.data.resultEntity && res.data.data.resultEntity.snaplet) {
        snaplet = res.data.data.resultEntity;
      }
      commit(constants.GET_WEB_ALIPAY_PAGE_SNAPLET_SUCCESS, snaplet);
    }
    //commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async makeMallAlipaySnapletTradeHtml({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.makeMallAlipaySnapletTradeHtml(payload);
    commit(constants.GET_WEB_ALIPAY_PAGE_SNAPLET_SUCCESS, res.data.data);
    //commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  //async getMallAlipayNotification({ commit }, payload) {
  //  commit(constants.SET_IS_REQUEST_STATUS, true);
  //  const res = await services.makeMallAlipaySnapletHtml(payload);
  //  commit(constants.GET_MALL_ALIPAY_NOTIFICATION_SUCCESS, res.data.data);
  //  //commit(constants.SET_IS_REQUEST_STATUS, false);
  //},

  async mallAddForFree({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.mallAddForFree(payload);
    commit(constants.SET_CHECK_RESULT, {
      checkResult: res.data.data.checkResult,
      checkResultMessage: res.data.data.checkResultMessage,
    });
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async mallAddForTaobao({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.mallAddForTaobao(payload);
    commit(constants.SET_TAOBAO_ORDER_RESULT, res.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return res;
  },

  async _getMallCouponList({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_COUPON_LIST_STATUS, true);
    const pms = payload.getMallCouponList(payload.payload);
    const res = await pms;
    commit(constants.GET_MALL_COUPON_LIST_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_COUPON_LIST_STATUS, false);
    return pms;
  },

  getMallCouponList({ dispatch }, payload) {
    return dispatch('_getMallCouponList', {
      payload,
      getMallCouponList: services.getMallCouponList,
    });
  },

  getMallTradeCouponList({ dispatch }, payload) {
    return dispatch('_getMallCouponList', {
      payload,
      getMallCouponList: services.getMallTradeCouponList,
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
